import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useLiffProfile } from "../../context/LiffProfileContext";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import SectionHeaderPromo from "../header/SectionHeaderPromo";
import LoadingBar from "../LoadingBar";

// ✅ API Helper
const fetchClientRootPageId = async (headers) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/clients/this`,
      { headers }
    );
    return res.data?.data?.variables?.root_page_id || null;
  } catch (error) {
    console.error("Failed to fetch client root page ID:", error);
    return null;
  }
};

const fetchPromotionSections = async (pageId, headers) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/pages/${pageId}`;
    const response = await axios.get(apiUrl, { headers });
    return response.data?.data?.sections || [];
  } catch (error) {
    console.error("Failed to fetch promotion sections:", error);
    return [];
  }
};

const Promotion = () => {
  const { t, i18n } = useTranslation();
  const { authToken, userId } = useLiffProfile();

  const [items, setItems] = useState([]);
  const [visibleItems, setVisibleItems] = useState(6);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const headers = useMemo(
    () => ({
      "X-Client-Auth": process.env.REACT_APP_CLIENT_AUTH,
      "Accept-Language": i18n.language.toUpperCase(),
    }),
    [i18n.language]
  );

  useEffect(() => {
    const fetchData = async () => {
      /*if (!authToken || !userId) {
        setLoading(false);
        //setError(t("auth_required"));
        return;
      }*/

      try {
        const pageId = await fetchClientRootPageId(headers);

        if (!pageId) throw new Error("No page ID found");

        const sections = await fetchPromotionSections(pageId, headers);

        const eventSection = sections.find(
          (section) => section.type?.toLowerCase() === "event"
        );

        if (eventSection && Array.isArray(eventSection.items)) {
          const eventData = eventSection.items.map((item, index) => {
            const language = i18n.language || "th";
            return {
              id: item.id || index + 1,
              image: item.image,
              title:
                item.names?.[language] ||
                item.name ||
                t("promotion_title", { number: index + 1 }),
              date:
                item.periodDescs?.[language] ||
                item.periodDescs?.en ||
                t("promotion_date"),
              url: item.targetURI || `/promotion/${index + 1}`,
            };
          });
          setItems(eventData);
        } else {
          setItems([]);
        }
      } catch (err) {
        console.error("Error fetching promotions:", err);
        setError(t("failed_to_load_promotions"));
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "promotions_view"
    });
    
  }, [headers, i18n.language, t]);

  useEffect(() => {
    sessionStorage.setItem("previousPath", window.location.pathname);

    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 100
      ) {
        setVisibleItems((prev) => prev + 6);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <ProfileWithBackButtonHeader />
      <div className="bg-[#f6f6f6] w-full px-5 xs:px-2">
        <SectionHeaderPromo
          className="py-4"
          name={t("main_promotion")}
          eventSection={true}
          seniorLayout={false}
        />

        {loading ? (
          (<LoadingBar loading={loading} label="Loading..." /> /*: error ? (
          <p className="text-center w-full py-4 text-red-500">{error}</p>
        )*/ /*: error ? (
          <p className="text-center w-full py-4 text-red-500">{error}</p>
        )*/ /*: error ? (
          <p className="text-center w-full py-4 text-red-500">{error}</p>
        )*/)
        ) : items.length > 0 ? (
          <div className="w-full grid grid-cols-2 gap-4 xs:gap-2 pb-5">
            {items.slice(0, visibleItems).map((item) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full no-underline"
                onClick={() => {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "promotion_click",
                    promotion_id: item.id,
                    promotion_title: item.title,
                    promotion_url: item.url,
                  });
                }}
              >
                <div className="grid grid-rows-auto cursor-pointer">
                  <div className="w-full h-auto rounded-2xl overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="px-2 font-normal pt-1.5 line-clamp-1 text-base text-left">
                    {item.title}
                  </div>
                  <div className="px-2 font-normal text-danger text-xs h-4 text-left">
                    {item.date}
                  </div>
                </div>
              </a>
            ))}
          </div>
        ) : (
          <p className="text-center w-full py-4">
            {t("no_promotion_available")}
          </p>
        )}
      </div>
    </>
  );
};

export default Promotion;
